import { useState, useEffect } from 'react';
import { useRequest } from 'ahooks';
import { queryPageAuthority } from '@gp/services/global';

export default function useProjectInfoAccessable(props: { loading: boolean; data?: any }) {
  const { loading, data } = props;

  useRequest(queryPageAuthority, {
    defaultParams: [{ assort: 'projectlist' }],
    onSuccess: (res) => {
      const { pps_view: ppsView, pps_edit: ppsEdit } = res || {};
      setPPSViewable(!!ppsView);
      setPPSEditable(!!ppsEdit);
      setShowRight(true);
    },
    onError: () => {},
  });

  // 是否展示右侧的搜索框、展开/折叠PPS字段信息列、数据下载按钮（首次加载时，需要等接口返回是否有PPS查看权限后，才展示右侧内容，避免突然出现按钮，导致搜索框左右抖动问题）
  const [showRight, setShowRight] = useState(false);
  // 控制status和pps_comment的查看权限，只要有一个project有这两列的查看权限就会显示
  const [ppsViewable, setPPSViewable] = useState(false);
  const [ppsEditable, setPPSEditable] = useState(false);
  // 控制Project Updates的查看权限，只要有一个project有查看权限就会显示
  const [updatesViewable, setUpdatesViewable] = useState(false);

  useEffect(() => {
    if (loading) return;
    const updatesViewable = data?.items?.some((item: any) => !!item?.updates_info?.view_update);
    // setUpdatesViewable(!!updatesViewable);
    setUpdatesViewable(true);
  }, [loading]);

  return { showRight, ppsViewable, ppsEditable, updatesViewable };
}
